// handling rowspan coloring
document
  .querySelectorAll('.table')
  .forEach(($el) => {
    if ($el.querySelector('tbody tr td[rowspan]')) {
      $el.classList.add('table--rowspan');
    }
  });
document
  .querySelectorAll('.table--rowspan tbody')
  .forEach(($el) => {
    let skipIndex = 0;
    let rowSpanEven = true;
    $el.querySelectorAll('tr').forEach(($tr, index) => {
      // get rowspan number for skipping indexes
      if ($tr.querySelector('td[rowspan]')) {
        const rowspan = parseInt($tr.querySelector('td[rowspan]').getAttribute('rowspan'), 10);
        rowSpanEven = !rowSpanEven;
        skipIndex = index + rowspan;
      }
      // if singleline is following
      if (index === skipIndex) {
        rowSpanEven = !rowSpanEven;
      }
      // skip indexes
      if (index <= skipIndex && rowSpanEven) {
        $tr.classList.add('table__row--even');
      }
    });
  });

// handling column highlighting
document
  .querySelectorAll('.table--column-highlighted')
  .forEach(($el) => {
    const colHighlighted = parseInt($el.getAttribute('data-colhighlight'), 10);
    const highlightClass = 'table-td--highlighted';
    $el.querySelectorAll('tr').forEach(($tr) => {
      const childToHightlight = $tr.children[colHighlighted - 1];
      if (!childToHightlight) return;
      childToHightlight.setAttribute('class', highlightClass);
    });
  });



// WEBPACK FOOTER //
// ./src/components/atoms/table/table.js